
import { ShippingTrackingResponse } from "../../Models/ShippingTracking";
import { formatDateTimeToBR } from "../../Utils/DataFormatters";
import Modal from "../common/Modal/Modal";

type ShippingTrackingEventsModalProps = {
  isOpen: boolean;
  isLoading?: boolean;
  tracking?: ShippingTrackingResponse | null;
  onClose: () => void;
};

const ShippingTrackingEventsModal = ({
  isOpen,
  isLoading = false,
  tracking,
  onClose
}: ShippingTrackingEventsModalProps) => {
  const events = tracking?.events ?? [];
  const title = tracking?.trackingCode
    ? `${"Rastreio"}: ${tracking.trackingCode}`
    : "Rastreio do pedido";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isDismissable={!isLoading}
      title={title}
    >
      <div className="flex flex-col gap-4">
        {!isLoading && tracking?.message && (
          <p className="text-sm text-gray-600">{tracking.message}</p>
        )}

        {isLoading ? (
          <p className="text-sm text-gray-600">{"Carregando eventos..."}</p>
        ) : events.length === 0 ? (
          <p className="text-sm text-gray-600">{"Nenhum evento de rastreio encontrado."}</p>
        ) : (
          <div className="flex flex-col gap-3 max-h-[55vh] overflow-y-auto pr-1">
            {events.map((event, index) => (
              <div
                key={`${event.createdAt ?? "event"}-${index}`}
                className="border border-gray-200 rounded-md p-3"
              >
                <p className="text-sm font-semibold text-gray-800">
                  {event.description ?? "Evento"}
                </p>
                {event.createdAt && (
                  <p className="text-xs text-gray-500">
                    {formatDateTimeToBR(event.createdAt)}
                  </p>
                )}
                {event.detail && (
                  <p className="text-sm text-gray-600 mt-1">{event.detail}</p>
                )}
                {(event.location || event.destination) && (
                  <p className="text-xs text-gray-500 mt-2">
                    {event.location && `${"Origem"}: ${event.location}`}
                    {event.location && event.destination ? " • " : ""}
                    {event.destination && `${"Destino"}: ${event.destination}`}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ShippingTrackingEventsModal;
